import { faAnglesRight } from "@fortawesome/pro-regular-svg-icons/faAnglesRight";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconAnglesRight: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faAnglesRight} />;
};
